import CardMenu from "components/card/CardMenu";
import Card from "components/card";
import * as XLSX from 'xlsx';
import { RiFileExcel2Line } from "react-icons/ri";
import { IoPrintOutline } from "react-icons/io5";
import React, { useEffect, useMemo, useState } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ReactSwitch from 'react-switch';
import { useDispatch, useSelector } from "react-redux";
import { StockReport, TransactionReport } from "../../../Redux/Report/action";
import { IoEyeSharp } from "react-icons/io5";
import { MdOutlineFilterAlt } from "react-icons/md";
import { MdOutlineFilterAltOff } from "react-icons/md";
import { filter } from "@chakra-ui/system";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ReactToPrint from "react-to-print";
import PrintIssueReport from "views/Print/PrintIssueReport";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useExcelGenerator } from "views/Print/useIssueExcel";
import { format } from "date-fns";


const IssueReportPage = () => {
const navigate=useNavigate()
const componentRef = React.useRef();
    const [SelectType, setSelectType] = useState("1");
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [checked, setChecked] = useState(false);
    const [Filter, setFilter] = useState(false)
//     const formattedfromDate = new Date(fromDate).toISOString();
// const formattedtoDate = new Date(toDate).toISOString();
const [filters, setFilters] = useState({
  BillNumber: '',
  PartyName: '',
  item: '',
  startDate: '',
  endDate: '',
});
const fromdate = new Date(fromDate);
const transactionlist = useSelector((state) => state?.Report?.transaction);
fromdate.setUTCHours(0);
fromdate.setUTCMinutes(0);
fromdate.setUTCSeconds(0);

const formattedfromDate = fromdate.toISOString().slice(0, 10) + " 00:00:00.000";

const todate = new Date(toDate);

todate.setUTCHours(0);
todate.setUTCMinutes(0);
todate.setUTCSeconds(0);

const formattedtoDate = todate.toISOString().slice(0, 10) + " 00:00:00.000";


// Function to handle input change for filters
const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters({
    ...filters,
    [name]: value,
  });
};

useEffect(() => {
  // console.log("filters",transactionlist);
  
  const filtered = transactionlist?.length>0 ?transactionlist?.filter((item) => {
    return (
      (!filters.BillNumber || item.BillNumber.includes(filters.BillNumber)) &&
      (!filters.BillDate || formatDate(item.BillDate).includes(filters.BillDate)) &&
      (!filters.PartyName || item.PartyName.toLowerCase().includes(filters.PartyName.toLowerCase())) &&
      (!filters.item || item.item.toLowerCase().includes(filters.item.toLowerCase()))
    );
  }):[];
  const updatedFiltered = filtered?.map(item => ({
    ...item, 
    selectedType: SelectType, 
  }));
  setFilteredData(updatedFiltered);
}, [filters, transactionlist]);


    const TempleID = JSON.parse(localStorage.getItem("Sopanam_TempleId"));
    const stocklist =useSelector((state)=>state.Report.stock)

    // const totalamount =
    // transactionlist.length &&
    // transactionlist?.reduce((total, item) => total + item.BillAmount, 0);

    const totalamount =
    transactionlist?.length &&
    Array.isArray(transactionlist)?transactionlist?.reduce((total, item) => total + item.BillAmount, 0):0
    const totalFetchedQuantity =
    transactionlist?.length &&
    Array.isArray(transactionlist)?transactionlist?.reduce((total, item) => total + item.FetchedQuantity, 0):0
    const totalIssuedQuantity =
    transactionlist?.length &&
    Array.isArray(transactionlist)?transactionlist?.reduce((total, item) => total + item.Quantity, 0):0
    console.log("totalamount",totalamount);

    const handleChange = val => {
      setChecked(val)
    }

const dispatch =useDispatch();

const [filteredData, setFilteredData] = useState(transactionlist);

useEffect(()=>{
    dispatch(TransactionReport({
        Type:1,
        TempleId:TempleID,
        From:formattedfromDate,
        To:formattedtoDate
    }))
},[formattedfromDate,formattedtoDate,SelectType])




const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
  
    // Pad single digits with leading zeros
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;
  
    return `${formattedDay}/${formattedMonth}/${year}`;
  };

  const onHandleEditClick=(data)=>{
console.log("clciked",parseInt(data?.selectedType));
const type=parseInt(data?.selectedType)
if(type==2){
  navigate(`/admin/Purchasepage/${data?.Id}`)
  
}else if(type==1){
  navigate(`/admin/Sale/${data?.Id}`)
}else if(type==6){
  navigate(`/admin/Returnsale/${data?.Id}`)
}
else if(type==4){
  navigate(`/admin/OrderPurchase/${data?.Id}`)
}
else if(type==7){
  navigate(`/admin/ReturnPurchase/${data?.Id}`)
}
else if(type==5){
  navigate(`/admin/Dispatch/${data?.Id}`)
}
else{
  toast.error("not applicable")
}

  }
  const [isLoading, setIsLoading] = useState(true);
  const [isDataReady, setIsDataReady] = useState(false);
  const [printTrigger, setPrintTrigger] = useState(false);

  // Simulate data loading
  useEffect(() => {
    if (filteredData && filteredData.length > 0) {
      setIsLoading(false); // Data is available
    }
  }, [filteredData]);

  const handlePrintWithJsPDF = async () => {
    if (!isDataReady) {
      console.error("Data not ready for printing");
      return;
    }
    
    setIsLoading(true);
    
    try {
      // Wait for any pending renders to complete
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Get the print content element
      const contentElement = componentRef.current;
      
      if (!contentElement) {
        console.error("Print element not found");
        setIsLoading(false);
        return;
      }
      
      // Show the print element during capture (will be hidden again after)
      const originalDisplay = contentElement.style.display;
      contentElement.style.display = "block";
      
      // Use html2canvas with optimal settings
      const canvas = await html2canvas(contentElement, {
        scale: 2, // Higher resolution
        useCORS: true,
        logging: false,
        windowWidth: contentElement.scrollWidth,
        windowHeight: contentElement.scrollHeight,
        // This ensures proper rendering of elements
        onclone: (clonedDoc) => {
          const clonedElement = clonedDoc.querySelector('.print');
          if (clonedElement) {
            clonedElement.style.display = 'block';
          }
        }
      });
      
      // Reset display style
      contentElement.style.display = originalDisplay;
      
      // Create PDF
      const imgData = canvas.toDataURL('image/jpeg');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      let heightLeft = imgHeight;
      let position = 0;
      
      // Add first page
      pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      
      // Add additional pages if needed
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      
      // Open in same window and trigger print
      const pdfBlob = pdf.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = pdfUrl;
      
      document.body.appendChild(iframe);
      
      iframe.onload = () => {
        iframe.contentWindow.print();
        
        // Clean up
        setTimeout(() => {
          URL.revokeObjectURL(pdfUrl);
          document.body.removeChild(iframe);
          setIsLoading(false);
        }, 500);
      };
    } catch (error) {
      console.error('Error generating PDF:', error);
      setIsLoading(false);
    }
  };

const {exportToExcel}=useExcelGenerator()

const onHandleXlGenerate=()=>{
  const headers = ["Bill No", "Bill Date", "Item Name","Fetched Quantity","Issued Quantity","Party","Bill Generate Date","Session"]
  const temple=filteredData?.[0]?.TempleName
  console.log(temple,"temple");

  const from=format(filteredData && filteredData?.[0]?.FromDate,"dd-MM-yyyy")
  const To=format(filteredData && filteredData?.[0]?.ToDate,"dd-MM-yyyy")
    const TableReport=filteredData?.map((data)=>{
      console.log(data,"dgsajdgasfg");
      return{
        BillNumber:data.BillNumber,
        BillDate:format(data.BillDate,"dd-MM-yyyy"),
        item:data.item,
        FetchedQuantity:data.FetchedQuantity,
        Quantity:data.Quantity,
        PartyName:data.PartyName,
        IssueDate:format(data.BillDate,"dd-MM-yyyy"),
        SessionName:data.SessionName
      }
    });
exportToExcel({data:TableReport,headers:headers,temple:temple,from:from,to:To})
}
  return (
    <div>
<PrintIssueReport ref={componentRef} filteredData={filteredData} onDataReady={setIsDataReady}/>
    <Card extra={"w-full h-full p-4"}>
      <div className="relative flex items-center justify-between">
        <div className="pb-5 text-xl font-bold text-navy-700 dark:text-white">
        Issue Report 
        </div>
        </div>
      <div className="relative flex ">
       
        <div className="pb-5 mt-4">
    
         <DatePicker
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            placeholderText="From Date"
            dateFormat="dd/MM/yyyy"
            selectsStart
            className="mr-5"
          />
         </div>
         <div className="mt-4">
         <DatePicker
            selected={toDate}
            onChange={(date) => setToDate(date)}
            placeholderText="To Date"
            selectsEnd
            dateFormat="dd/MM/yyyy"
            className="mr-5"
          />
        </div>
        <div className="flex items-center gap-2">
        <ReactToPrint
                trigger={() => (
                  <button
                    class={`${!isDataReady
                    ? "bg-gray-400 cursor-not-allowed":""}mb-2 rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-medium text-white me-2 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
                    type="button"
                    disabled={!isDataReady}
                    onClick={() => setPrintTrigger(prev => !prev)}
                  >
                    Print
                  </button> 
                )}
                content={() => componentRef.current}
                onAfterPrint={() => {
                  // reset();
                  // setChoosedItems([]);
                  // setQty("");
                  // setselectitem("");
                  // setTablelist([]);
                  // Dispatch(SaleInsertFail());
                  // Dispatch(PrintPurchaseFail())
                }}
                onBeforeGetContent={ () => {
                  return new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                    }, 2000); // Adjust timeout as needed
                  });
                }}
              />
              <button className={`${!isDataReady
                ? "bg-gray-400 cursor-not-allowed" 
                : ""}mb-2 rounded-lg bg-green-700 px-5 py-2.5 text-sm font-medium text-white me-2 hover:bg-green-800 focus:outline-none focus:ring-4 focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800`}
              type="button"
              onClick={()=>onHandleXlGenerate()}>
                Export
              </button>
              {/* <button
              className={`${!isDataReady
                ? "bg-gray-400 cursor-not-allowed" 
                : ""}mb-2 rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-medium text-white me-2 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
              type="button"
              disabled={!isDataReady || isLoading}
              onClick={handlePrintWithJsPDF}
            >
              {isLoading ? "Processing..." : "Print"}
            </button> */}
        </div>
        {/* <div className="pb-5 mr-6 text-xl font-bold text-navy-700 dark:text-white">
        <select
                className="block w-full rounded-lg border border-green-500 border-gray-700 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
                id="party"
                value={SelectType}
                onChange={(e) => setSelectType(e.target.value)}
              >
          <option value="0">Select Type</option>
          <option value="1">Issue</option>
          <option value="6">Issue Return</option>
          <option value="2">Purchase</option>
          <option value="4">Purchase Order</option>
          <option value="7">Purchase Return</option>
          <option value="5">Damage</option>
        </select>
        </div> */}
        <div className="flex justify-end  w-full">{Filter?<MdOutlineFilterAltOff size={28} onClick={()=>{setFilter(false)}}/>:<MdOutlineFilterAlt size={28} onClick={()=>{setFilter(true)}}/>}</div>
        </div>
{Filter?<div> <div className="mb-4 grid grid-cols-4 gap-4">
        <input
          type="text"
          name="BillNumber"
          value={filters.BillNumber}
          onChange={handleFilterChange}
          placeholder="Filter by Bill No"
          className="border p-2"
        />
        <input
          type="text"
          name="BillDate"
          value={filters.BillDate}
          onChange={handleFilterChange}
          placeholder="Filter by Date"
          className="border p-2"
        />
        <input
          type="text"
          name="PartyName"
          value={filters.PartyName}
          onChange={handleFilterChange}
          placeholder="Filter by Party Name"
          className="border p-2"
        />
        <input
          type="text"
          name="item"
          value={filters.item}
          onChange={handleFilterChange}
          placeholder="Filter by Item Name"
          className="border p-2"
        />
      </div>
</div>:''}
      <div className="h-full md:h-[500px] md:overflow-y-auto ">
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-left text-sm text-gray-500 rtl:text-right dark:text-gray-400">
            <thead className="bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  SL NO
                </th>
                <th scope="col" className="px-6 py-3">
                Bill No
                </th>
                {/* <th scope="col" className="px-6 py-3">
                Invoice No
                </th>
                <th scope="col" className="px-6 py-3">
                Invoice Date
                </th> */}
                <th scope="col" className="px-6 py-3">
                Bill Date
                </th>
                <th scope="col" className="px-6 py-3">
               Party Name
                </th>
                <th scope="col" className="px-6 py-3">
               Item Name
                </th>
                <th scope="col" className="px-6 py-3">
                 Fetched Quantity
                </th>
                <th scope="col" className="px-6 py-3">
                 Issued Quantity
                </th>
                <th scope="col" className="px-6 py-3">
                Bill Entered Date
                </th>
                <th scope="col" className="px-6 py-3">
                Session
                </th>
                {/* <th scope="col" className="px-6 py-3">
               View
                </th> */}
                

              </tr>
            </thead>
            <tbody>
                
  {Array.isArray(filteredData) && filteredData.map((item, index) => {
    console.log(filteredData,"filteredData");
    const originalDate = item.BillDate;
    const orderDate = item.OrderDate;
    const BillEnteredDate=item?.IssueDate
    const formattedDate = formatDate(originalDate);
    const formattedBillDate = formatDate(orderDate);
    const formattedIssuedDate = formatDate(orderDate);
    const formatedBillEnteredDate=formatDate(BillEnteredDate);
    return(
    <tr key={index} className={`border-b ${index % 2 === 0 ? 'even:bg-gray-50 dark:bg-gray-800' : 'odd:bg-white'} ${index % 2 === 0 ? 'even:bg-gray-800 dark:bg-gray-800' : 'odd:bg-gray-900'}`}>
      <td className="px-6 py-4 text-gray-900">{index + 1}</td>
      <td className="px-6 py-4 text-gray-900">{item.BillNumber}</td>
      {/* <td className="px-6 py-4 text-gray-900">{item.InvoiceNo}</td>
      <td className="px-6 py-4 text-gray-900">{formattedDate}</td> */}
      <td className="px-6 py-4 text-gray-900">{formattedBillDate}</td>
      <td className="px-6 py-4 text-gray-900">{item.PartyName}</td>
      <td className="px-6 py-4 text-gray-900">{item.item}</td>
      <td className="px-6 py-4 text-gray-900">{item?.FetchedQuantity?.toFixed(3) ?? "0.000"}</td>
      <td className="px-6 py-4 text-gray-900">{item.Quantity?.toFixed(3) ?? "0.000"}</td>
      <td className="px-6 py-4 text-gray-900">{formatedBillEnteredDate}</td>
      <td className="px-6 py-4 text-gray-900">{item.SessionName}</td>
      {/* <td className="px-6 py-4 text-gray-900">
        <MdEdit onClick={()=>onHandleEditClick(item)} className="hover:text-blue-500 cursor-pointer transition-colors duration-200" />
        </td> */}
    
    </tr>
)})}
<tr>
                  <td>
                    
                  </td>
                  <td  colSpan={2} className="mt-1 "><div
                      className=" mt-5 p-1"
                      style={{ color: "black"}}
                    >
                      {/* <b>Total Fetched Quantity:</b>{" "} */}
                    </div></td>
                  <td>
                    {" "}
                    <div
                      className=" ml-4  mt-5 flex p-1"
                      style={{ color: "black" }}
                    >
                      {" "}
                      {/* <b>{OpeningStockvalue}</b>{" "} */}
                    </div>{" "}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  
                  
                  <td >
                    {" "}
                    <div
                      className=" ml-4  mt-5 flex p-1"
                      style={{ color: "black" }}
                    >
                      {" "}
                      {/* <b>{totalFetchedQuantity?.toFixed(2)??''} </b>{" "} */}
                    </div>{" "}
                  </td>
                </tr>
 
<tr>
                 
                  <td></td>
                  <td colSpan={2} className="mt-1 ">
                    <div
                      className=" mt-5 p-1"
                      style={{ color: "black"}}
                    >
                      {/* <b>Total Issued Quantity:</b>{" "} */}
                    </div>
                  </td>
                  <td>
                    {" "}
                    <div
                      className=" ml-4  mt-5 flex p-1"
                      style={{ color: "black" }}
                    >
                      {" "}
                      {/* <b>{OpeningStockvalue}</b>{" "} */}
                    </div>{" "}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  
                  
                  <td >
                    {" "}
                    <div
                      className=" ml-4  mt-5 flex p-1"
                      style={{ color: "black" }}
                    >
                      {" "}
                      {/* <b>{totalIssuedQuantity?.toFixed(2)??''} </b>{" "} */}
                    </div>{" "}
                  </td>
                </tr>
 

</tbody>

          </table>
        </div>
      </div>
    </Card>
    </div>
  );
};

export default IssueReportPage;
